import { render, staticRenderFns } from "./ChangePasswordMany.vue?vue&type=template&id=305fee9c&scoped=true"
import script from "./ChangePasswordMany.vue?vue&type=script&lang=js"
export * from "./ChangePasswordMany.vue?vue&type=script&lang=js"
import style0 from "./ChangePasswordMany.vue?vue&type=style&index=0&id=305fee9c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305fee9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('305fee9c')) {
      api.createRecord('305fee9c', component.options)
    } else {
      api.reload('305fee9c', component.options)
    }
    module.hot.accept("./ChangePasswordMany.vue?vue&type=template&id=305fee9c&scoped=true", function () {
      api.rerender('305fee9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/school/ChangePasswordMany.vue"
export default component.exports